<template>
  <div class="to-user-tasks text-dark">
    <table class="d-table marg-1-bottom d-table__overview">
        <tbody v-for="(tasksType, prop) in tasksByMasterType">
        <tr class="tr-thead">
          <td><h4>{{ tasksType.title }}</h4></td>
          <td>{{ $t('vue2.task_overview.belongs_to') }}</td>
          <td class="td-dates"><template v-if="hasAnyDatesInGroup(tasksType)">Dato</template></td>
          <td class="is-number">{{ $t('vue2.assign_users_hours.assigned') }}</td>
        </tr>
        <tr
          v-for="task in tasksType.tasks"
          :key="task.id"
          :class="{'to-user-tasks__row--editable': canEditTask(task)}"
          :title="canEditTask(task) ? $t('vue2.common.edit') : null"
          @click="onTaskClick(task)">
          <td>{{ task.name }}</td>
          <td>{{ getCalendarNames(task) }}</td>
          <td class="td-dates">{{ formatDateRange(task.from_date, task.to_date) }}</td>
          <td class="is-number"><template v-if="!getIsHideHours(task)">{{ formatHours(task.hours) }}</template></td>
        </tr>
        <tr class="to-user_tasks__footer" v-if="!getIsHideTotalHours(tasksType)">
          <td>I alt</td>
          <td></td>
          <td></td>
          <td class="is-number">{{ formatHours(tasksType.totalHours) }}</td>
        </tr>
        </tbody>
    </table>
  </div>
</template>

<script>
import UserTasksTable from '../UserTasksTable'
import moment from 'moment'

export default {
  components: {UserTasksTable},
  props: {
    user: {
      type: Object,
      required: true
    },
    tasks: {
      default: () => []
    },
    isHideTaskHoursUnderThreshold: {
      default: false
    },
    schoolThresholdToHideTaskHours: {
      default: null
    },
    sortOrder: {
      default: null
    },
    tasksByMasterType: {
      type: Array,
      default: () => []
    },
    canEditTasks: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    canEditTask (task) {
      return this.canEditTasks && task && task.id && !task.substitute
    },
    onTaskClick (task) {
      if (!this.canEditTask(task)) {
        return
      }
      this.$emit('editTask', task)
    },
    formatHours (value) {
      const num = parseFloat(value)
      if (isNaN(num)) return value
      return Math.round(num * 100) / 100
    },
    getCalendarNames (task) {
      if (!task.calendars) {
        return task.calendar || ''
      }
      var calendars = task.calendars
      if (typeof calendars === 'string') {
        try {
          calendars = JSON.parse(calendars)
        } catch (e) {
          return task.calendar || ''
        }
      }
      if (!Array.isArray(calendars) || calendars.length < 1) {
        return task.calendar || ''
      }
      var klassNames = []
      for (var i = 0; i < calendars.length; i++) {
        if (calendars[i].calendar_type === 'klass') {
          klassNames.push(calendars[i].name)
        }
      }
      if (klassNames.length < 1) {
        return task.calendar || ''
      }
      if (klassNames.length <= 4) {
        return klassNames.join(', ')
      }
      return klassNames.slice(0, 4).join(', ') + ' ...'
    },
    getIsHideHours (task) {
      return task.hours * 1 === 0 || (this.isHideTaskHoursUnderThreshold && task.subject_type === 'additional_tasks' && (task.hours * 1) < this.schoolThresholdToHideTaskHours)
    },
    getIsHideTotalHours (tasksType) {
      return tasksType.totalHours < 1 || (this.isHideTaskHoursUnderThreshold && this.schoolThresholdToHideTaskHours && tasksType.originalType === 'other')
    },
    hasAnyDatesInGroup (tasksType) {
      return tasksType.tasks.some(task => task.from_date || task.to_date)
    },
    formatDateRange (fromDate, toDate) {
      if (!fromDate && !toDate) return ''
      const from = fromDate ? moment(fromDate) : null
      const to = toDate ? moment(toDate) : null
      if (from && !to) return from.format('DD-MM-YYYY')
      if (!from && to) return to.format('DD-MM-YYYY')
      if (from.isSame(to, 'day')) return from.format('DD-MM-YYYY')
      return from.format('DD-MM-YYYY') + ' - ' + to.format('DD-MM-YYYY')
    }
  }
}
</script>

<style scoped>

.d-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
}

.d-table > thead,
.tr-thead {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th,
.d-table > tfoot > tr > td,
.tr-thead td {
  padding: 5px !important;
}

.d-table > thead > tr:first-child,
.tr-thead{
  color: #8898aa;
}

.d-table tr th,
.d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tr th h4,
.tr-thead h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 4px;
}

.is-number {
  text-align: right;
}

.d-table tr:not(.tr-thead) td:first-child {
  padding-left: 2rem;
}


.to-user_tasks__footer {
  border-top: 1px solid #e2e8f0;
}

.to-user_tasks__footer .is-number {
  font-weight: bold;
}

.td-dates {
  white-space: nowrap;
  font-size: 11px;
  color: #8898aa;
}

.to-user-tasks__row--editable {
  cursor: pointer;
}

.to-user-tasks__row--editable:hover {
  background-color: aliceblue;
}

@media print {
  .to-user-tasks__row--editable {
    cursor: default;
  }
  .to-user-tasks__row--editable:hover {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// TaskOverviewUserTasks.vue?ba8653d4